export default __webpack_public_path__ + "static/media/green-clock.9e60a087.png";